import APIClient from './index';
import _ from 'lodash';

export const getProductReviews = (Product_id, params = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.get(`/v2/Reviews/${Product_id}?${new URLSearchParams(params).toString()}`)
      .then(response => resolve(response.data))
      .catch(error => reject(_.get(error, ['data', 'error'])));
  });
};
